import React, {useState} from "react";
import {Button, Col, Form, Spinner} from "react-bootstrap";
import {ErrorMessage, Formik} from "formik";
import * as yup from "yup";

import {REGEX_FULLDOMAIN} from "../../../constants";
import {autoConnectDomainAdd} from "../../../services/custom-domain";

const checkNoDuplicate = (domains, value = '') =>
    !domains.includes(value)

const Add = ({domains, onSuccess, onFail}) => {
    const [loading, setLoading] = useState(false);

    const schema = yup.object({
        domain: yup
            .string()
            .matches(REGEX_FULLDOMAIN, "Please enter a valid domain")
            .required('Please enter a domain')
            .test(
                'domain',
                'Domain already added',
                (value) => checkNoDuplicate(domains, value)
            ),
        owner: yup.bool()
          .oneOf([true], "You must already own this domain or have access to modify it's settings")
          .required()

    });

    const onFormSubmit = (data) => {
        setLoading(true);
        autoConnectDomainAdd(data)
            .then(({data: {domain, token, cert, cfName}}) => {
                setLoading(false);
                onSuccess(domain, token, cert, cfName)
            })
            .catch((e) => {
                setLoading(false);
                onFail()
            });
    };

    return <Formik
        validationSchema={schema}
        onSubmit={onFormSubmit}
        initialValues={{
            domain: '',
            owner: false
        }}
    >
        {({handleSubmit, handleChange, values, touched, errors}) =>
            (<Form noValidate onSubmit={handleSubmit}>
                <div className="pt-3 pe-3 ps-3">
                    <div>Add domain name</div>
                    <div className="flex mt-3">
                        <Form.Group controlId="validationFormikDomain" style={{flex: 5}}>
                            <Form.Control
                                name="domain"
                                type="text"
                                placeholder="e.g. mydomain.com"
                                value={values.domain}
                                onChange={handleChange}
                                isValid={touched.domain && !errors.domain}
                            />
                            <ErrorMessage name="domain" component="div" className="validation-error"/>
                        </Form.Group>
                    </div>
                    <Form.Check
                      name="owner"
                      className="mt-3"
                      type="checkbox"
                      value={values.owner}
                      onChange={handleChange}
                      label="I own this domain / I can instruct DNS changes"
                    />
                    <ErrorMessage name="owner" component="div" className="validation-error"/>
                </div>
                <Button
                    className="action-btn round-top-0 mt-4"
                    type="submit"
                    disabled={loading}
                >
                    {loading ? <Spinner animation="border"/> : 'ADD'}
                </Button>
            </Form>)}
    </Formik>
}

export default Add